export var EarthDayTextureQuality;
(function (EarthDayTextureQuality) {
    EarthDayTextureQuality["POTATO"] = "512";
    EarthDayTextureQuality["LOW"] = "1k";
    EarthDayTextureQuality["MEDIUM"] = "2k";
    EarthDayTextureQuality["HIGH"] = "4k";
    EarthDayTextureQuality["ULTRA"] = "16k";
})(EarthDayTextureQuality || (EarthDayTextureQuality = {}));
export var EarthNightTextureQuality;
(function (EarthNightTextureQuality) {
    EarthNightTextureQuality["POTATO"] = "512";
    EarthNightTextureQuality["LOW"] = "1k";
    EarthNightTextureQuality["MEDIUM"] = "2k";
    EarthNightTextureQuality["HIGH"] = "4k";
    EarthNightTextureQuality["ULTRA"] = "16k";
})(EarthNightTextureQuality || (EarthNightTextureQuality = {}));
export var EarthSpecTextureQuality;
(function (EarthSpecTextureQuality) {
    EarthSpecTextureQuality["OFF"] = "off";
    EarthSpecTextureQuality["POTATO"] = "256";
    EarthSpecTextureQuality["LOW"] = "1k";
    EarthSpecTextureQuality["MEDIUM"] = "2k";
    EarthSpecTextureQuality["HIGH"] = "4k";
    EarthSpecTextureQuality["ULTRA"] = "16k";
})(EarthSpecTextureQuality || (EarthSpecTextureQuality = {}));
export var EarthBumpTextureQuality;
(function (EarthBumpTextureQuality) {
    EarthBumpTextureQuality["OFF"] = "off";
    EarthBumpTextureQuality["LOW"] = "256";
    EarthBumpTextureQuality["MEDIUM"] = "4k";
    EarthBumpTextureQuality["HIGH"] = "8k";
})(EarthBumpTextureQuality || (EarthBumpTextureQuality = {}));
export var EarthCloudTextureQuality;
(function (EarthCloudTextureQuality) {
    EarthCloudTextureQuality["OFF"] = "off";
    EarthCloudTextureQuality["POTATO"] = "512";
    EarthCloudTextureQuality["LOW"] = "1k";
    EarthCloudTextureQuality["MEDIUM"] = "2k";
    EarthCloudTextureQuality["HIGH"] = "4k";
    EarthCloudTextureQuality["ULTRA"] = "8k";
})(EarthCloudTextureQuality || (EarthCloudTextureQuality = {}));
export var EarthPoliticalTextureQuality;
(function (EarthPoliticalTextureQuality) {
    EarthPoliticalTextureQuality["OFF"] = "off";
    EarthPoliticalTextureQuality["POTATO"] = "1k";
    EarthPoliticalTextureQuality["LOW"] = "2K";
    EarthPoliticalTextureQuality["MEDIUM"] = "4k";
    EarthPoliticalTextureQuality["HIGH"] = "8k";
    EarthPoliticalTextureQuality["ULTRA"] = "16k";
})(EarthPoliticalTextureQuality || (EarthPoliticalTextureQuality = {}));
export var EarthTextureStyle;
(function (EarthTextureStyle) {
    EarthTextureStyle["BLUE_MARBLE"] = "earthmap";
    EarthTextureStyle["NADIR"] = "earthmapalt";
    EarthTextureStyle["FLAT"] = "flat";
})(EarthTextureStyle || (EarthTextureStyle = {}));
export var AtmosphereSettings;
(function (AtmosphereSettings) {
    AtmosphereSettings[AtmosphereSettings["OFF"] = 0] = "OFF";
    AtmosphereSettings[AtmosphereSettings["ON"] = 1] = "ON";
})(AtmosphereSettings || (AtmosphereSettings = {}));
